// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const ZoomLogout = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.088 3.648v5.034a.5.5 0 0 0 1 0V3.648c0-1.544-1.308-2.8-2.917-2.8H3.042C1.434.848.125 2.104.125 3.648V18.652a.5.5 0 0 0 1 0V3.648c0-.993.86-1.8 1.917-1.8h8.129c1.058 0 1.918.807 1.918 1.8Zm6.756 8.092.008-.026a.497.497 0 0 0 .023-.142c0-.05-.01-.097-.023-.142l-.008-.026a.493.493 0 0 0-.067-.126l-.004-.008-2.076-2.746a.5.5 0 1 0-.798.603l1.471 1.945H9.775a.5.5 0 0 0 0 1h8.595l-1.471 1.945a.5.5 0 1 0 .797.603l2.077-2.747.005-.007a.505.505 0 0 0 .066-.126Zm-5.756 2.72v4.192a.5.5 0 0 1-1 0V14.46a.5.5 0 1 1 1 0Z"
			fill="#fff"
		/>
	</svg>
);
export default ZoomLogout;
